var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StepNavigation',{attrs:{"active-step":_vm.activeStep,"steps":_vm.totalSteps}}),(_vm.activeStep===1)?_c('StepOne'):_vm._e(),(_vm.activeStep===2)?_c('StepTwo'):_vm._e(),(_vm.activeStep===3)?_c('StepThree'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }